<app-navbar></app-navbar>
<div class="referral-card card-margin-top">
  <h2 class="title">Clinical details</h2>
  <textarea class="textarea" rows="4" [(ngModel)]="clinicalNotes"></textarea>

  <label class="mt">State of Care<span class="req">*</span></label>
  <select class="input" [ngModel]="state" (ngModelChange)="onStateChange($event)">
    <option value="">--Select State--</option>
    <option *ngFor="let s of stateOptions" [value]="s">{{ s }}</option>
  </select>
  <div class="invalid" *ngIf="submitted && !state">Please select your state</div>

  <label class="mt mb-3">Reason for visit<span class="req">*</span></label>
  <div class="gap-2 mb-3" *ngIf="CHOICE_STATES.includes(state); else onlyMedication">
    <label class="sch-label">
      <input type="radio" name="reason" value="medication" [(ngModel)]="reason" />
      <span class="radio-label-text">Intake for Medication Management</span>
    </label>
    <label class="sch-label">
      <input type="radio" name="reason" value="psychotherapy" [(ngModel)]="reason" />
      <span class="radio-label-text">Intake for Psychotherapy</span>
    </label>
  </div>
  <ng-template #onlyMedication>
    <label class="sch-label">
      <input type="radio" name="reason" value="medication" [(ngModel)]="reason" />
      <span class="radio-label-text">Intake for Medication Management</span>
    </label>
  </ng-template>
  <div class="invalid" *ngIf="submitted && !reason">Please select a reason</div>

  <label class="mt mb-3">Is the referring provider a DEA registered provider? <i>(Optional)</i></label>
  <div class="gap-2 mb-3">
    <label class="sch-label"><input type="radio" name="dea" value="Yes" [(ngModel)]="dea" /> <span class="radio-label-text">Yes</span></label>
    <label class="sch-label"><input type="radio" name="dea" value="No" [(ngModel)]="dea" /> <span class="radio-label-text">No</span></label>
    <label class="sch-label"><input type="radio" name="dea" value="Don't know" [(ngModel)]="dea" /> <span class="radio-label-text">Don't know</span></label>
  </div>

  <label class="mt mb-3">Did the referring provider see the patient in-person?</label>
  <div class="gap-2 mb-3">
    <label class="sch-label"><input type="radio" name="seen" value="Yes" [(ngModel)]="patientSeen" /> <span class="radio-label-text">Yes</span></label>
    <label class="sch-label"><input type="radio" name="seen" value="virtual" [(ngModel)]="patientSeen" /> <span class="radio-label-text">No, my evaluations of this patient have been virtual</span></label>
    <label class="sch-label"><input type="radio" name="seen" value="never" [(ngModel)]="patientSeen" /> <span class="radio-label-text">No, I have never evaluated this patient</span></label>
  </div>

  <div class="actions">
    <button class="btn outline pevious" [disabled]="loading" (click)="onPrevious()">Previous</button>
    <button class="btn primary next" [disabled]="!canSend" (click)="onSend()">Send</button>
  </div>
  <app-loader *ngIf="loading" [fullscreen]="true" [message]="'Submitting details'" ></app-loader>
</div>
<app-footer></app-footer>


